import 'slick-carousel';

const $ = jQuery;

export default {
    init() {
        setupValuesSlider();
    }
};

function setupValuesSlider() {
    const $blocks = $('.page-block-values-slider');

    if (!$blocks.length) {
        return;
    }

    $blocks.each(function() {
        const $container = $(this);
        const $slider = $container.find('.values-content-slider');
        const $tabButtons = $container.find('.value-tab-btn');

        if ($slider.hasClass('slick-initialized')) {
            return;
        }

        $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            fade: true,
            speed: 400,
            cssEase: 'cubic-bezier(0.25, 1, 0.5, 1)',
            infinite: true,
            adaptiveHeight: true,
            swipe: false,
            draggable: false,
            touchMove: false
        });

        $tabButtons.on('click', function() {
            const slideIndex = $(this).data('slide');
            $slider.slick('slickGoTo', slideIndex);
        });

        $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            $tabButtons.each(function(index) {
                const $btn = $(this);

                if (index === nextSlide) {
                    $btn.removeClass('bg-transparent text-black hover:text-fxd-purple inactive-tab')
                        .addClass('bg-fxd-purple text-white active-tab');
                } else {
                    $btn.removeClass('bg-fxd-purple text-white active-tab')
                        .addClass('bg-transparent text-black hover:text-fxd-purple inactive-tab');
                }
            });
        });
    });
}
